import React from 'react';
import { Icon as IconBaseComponent, IconProps } from '../../Icon';
import { useCustomComponent } from '@/hooks';

export interface ActionCardIconProps {
  name: IconProps['name'];
  color: string;
}

const IconComponent: React.FC<ActionCardIconProps> = ({ name, color }) => {
  return <IconBaseComponent name={name} color={color} />;
};

export const Icon: React.FC<ActionCardIconProps> = (
  props: ActionCardIconProps
) => {
  const Component = useCustomComponent({
    componentName: 'ActionCardIcon',
    Component: IconComponent,
  });

  return <Component {...props} />;
};
